import clsx from "clsx"
import { FC } from "react"
import { CardBackImg1 } from "@/assets"
import styles from "./Spinner.module.scss"
import { SpinnerProps } from "./types"

export const Spinner: FC<SpinnerProps> = ({ size = "md", text, className }) => {
  return (
    <div className={clsx(styles.Spinner, styles[size], className)}>
      <div className={styles.Spinner_cards}>
        <div className={styles.Spinner_card} style={{ animationDelay: "0s" }}>
          <img src={CardBackImg1} alt="" />
        </div>
        <div
          className={styles.Spinner_card}
          style={{ animationDelay: "0.15s" }}
        >
          <img src={CardBackImg1} alt="" />
        </div>
        <div className={styles.Spinner_card} style={{ animationDelay: "0.3s" }}>
          <img src={CardBackImg1} alt="" />
        </div>
      </div>

      {text && <p className={styles.Spinner_text}>{text}</p>}
    </div>
  )
}
